<template>
  <!-- Loading Spinner -->
  <MIcon
    id="loading-patch-btn"
    name="spinner-third"
    class="fa-spin"
    size="lg"
    style="margin-top: unset"
  />
</template>

<script>
import { getRedirectionUrl } from '@modules/project/project-api'
import { isLoggedIn } from '@utils/auth'

export default {
  name: 'UniversalView',
  created() {
    this.redirectToAppropriateRoute()
  },
  methods: {
    redirectToAppropriateRoute() {
      const id = this.$route.params.id
      const moduleName = this.$route.params.moduleName

      if (!isLoggedIn()) {
        return this.$router.replace(
          this.$modules.getModuleRoute('auth', 'login', {
            query: {
              redirectFrom: this.$route.fullPath,
            },
          })
        )
      } else {
        getRedirectionUrl(moduleName, id)
          .then((url) => {
            if (url) {
              window.location.replace(url)
            } else {
              // in case of no url, redirect to 404
              this.$router.replace({ name: '404' })
            }
          })
          .catch(() => {
            this.$router.replace({ name: '404' })
          })
      }
    },
  },
}
</script>
